$(function() {
  $(window).keydown(function(event){
    if(event.keyCode == 13) {
      event.preventDefault();
      return false;
    }
  });

  $('.form--event--register .btn--next').on('click', function(e) {
    if($('.form--event--register').hasClass('input--contact--person'))
      return false;

    $('.row--summary').remove();

    $('.form--event--register').addClass('input--contact--person');
    var $formGroup = $(this).closest('.form-group');
    if(!$formGroup.find('.spinner-border').length) {
      $formGroup.append('<div class="spinner-border spinner-border-sm" role="status"> <span class="sr-only">Loading...</span> </div>');
    }

    setTimeout(function(){
      $.post('/event/attendees', $('.form--event--register').serialize(), function(response) {
        if(response.status == 'success') {
          $('.form--event--register .container').append(response.view);
          $('.form--event--register .btn--next').html('Aktualisieren');
          if(!$('.form--event--register .btn--next').hasClass('btn-sm'))
            $('.form--event--register .btn--next').addClass('btn-sm');

          $('.form--event--register').removeClass('input--contact--person');
          $('html, body').animate({
              scrollTop: $('.row--summary').offset().top
          }, 1400);
        } else {

        }
        $formGroup.find('.spinner-border').remove();
      });
    }, 400);
  });

  $('.form--event--register select[name=attendees_amount]').on('change', function() {
    var $this = $(this);
    var amount = parseInt($this.val());
    var existingAmount = parseInt($('.container--attendee--entry .attendee--entry').length);
    if(amount < 1 || existingAmount < 1 || existingAmount == amount)
      return false;

    var $container = $('.container--attendee--entry');
    var $entry = $('.container--attendee--entry .attendee--entry.first').clone();
    $entry.find('input').val('');

    if(amount > existingAmount) {
      /* Füge die Differenz hinzu */
      for(var i = 0; i < (amount - existingAmount); i++) {
        $container.append('<div class="attendee--entry">' + $entry.html() + '</div>');
      }
    } else {
      /* Lösche die Differenz */
      $('.container--attendee--entry .attendee--entry').each(function(index) {
        var i = index + 1;
        if(i > amount) {
          $(this).remove();
        }
      });
    }
  });
});
